import type { ReactNode } from 'react';
import styles from './FieldStatusWrapper.module.css';

interface FieldStatusWrapperProps {
  children: ReactNode;
  isDirty?: boolean;
  className?: string;
}

/**
 * A wrapper component for form fields that displays a status indicator when the field is dirty (i.e., has unsaved changes).
 *
 * Props:
 * - children: The form field(s) to be wrapped.
 * - isDirty: A boolean indicating whether the field has unsaved changes.
 * - className: Additional CSS class names to apply to the wrapper.
 *
 * Requires CSS variable --field-status-offset to be defined in a parent component for correct positioning of the status indicator, equal to parent component's left padding.
 */
function FieldStatusWrapper({
  children,
  isDirty = false,
  className,
}: Readonly<FieldStatusWrapperProps>) {
  let wrapperClassName = styles.wrapper;
  if (isDirty) {
    wrapperClassName += ` ${styles.dirty}`;
  }
  if (className) {
    wrapperClassName += ` ${className}`;
  }

  return <div className={wrapperClassName}>{children}</div>;
}

export default FieldStatusWrapper;
